export const tituloColuna: string[] = [
  'competencia',
  'numeroCnpj',
  'numeroCaceal',
  'statusSolicitacao',
  'statusExtrato',
  'situacaoExtrato',
  'dataGeracao',
  'acoes'
];

export const definicaoColunas = [
  { column: 'competencia', header: 'Competência', sortable: true, class: 'mat-column-competencia' },
  { column: 'numeroCnpj', header: 'CNPJ', sortable: true, class: 'mat-column-cnpj' },
  { column: 'numeroCaceal', header: 'CACEAL', sortable: true, class: 'mat-column-caceal' },
  { column: 'statusSolicitacao', header: 'Status Solicitação', sortable: true, class: 'mat-column-statusSolicitacao' },
  { column: 'statusExtrato', header: 'Status Extrato', sortable: false, class: 'mat-column-statusExtrato' },
  { column: 'situacaoExtrato', header: 'Situação Extrato', sortable: true, class: 'mat-column-situacaoExtrato' },
  { column: 'dataGeracao', header: 'Data Geração', sortable: true, class: 'mat-column-dataGeracao' },
  { column: 'acoes', header: 'Ações', sortable: false, class: 'mat-column-acoes' }
];
